<template>
    <div style="position: relative; border-top-color: lightgray; border-top-style: solid; border-top-width: 1px;"  v-resize="onResize">
        <v-row class="no-frame w-100">
             <v-col class="no-border col-9 v-flex" style="position: relative">
                 <p-inc-bounced-mail
                     v-model       = "mail.visible"
                     :bounced-mail = mail.content
                     :height       = "mailHeight"
                 />

                <div class="todo-layout">
                    <div class="todo-units-total" :style="'height:' + height + 'px'">
                        <p-inc-units-total
                            :loading = "loading"
                            @changed = "onChanged"
                            @bounce  = "onBounce"
                        />
                    </div>
                    <div class="todo-groups-container">
                        <div class="todo-groups-toolbar">
                            <a @click.stop = "onRefresh" class="v-flex" v-if="isPrivileged">
                                <v-icon
                                    :size  = "24"
                                    color = "primary"
                                >
                                    mdi-refresh
                                </v-icon>

                                <div>
                                    {{ $t('common.refresh') }}
                                </div>
                            </a>
                            <v-spacer />
                            <v-switch
                                v-model = "onlyLM"
                                label   = "nur Anlagen im Liftmanagement"
                                color   = "primary"
                                :ripple = "false"
                                hide-details
                                class = "mt-0 pt-0"
                            />
                        </div>

                        <div class="todo-groups-grid">
                            <p-inc-measure-group
                                title     = "Ereignisse"
                                :measures = "incMeasures"
                                @click    = "onMeasure"
                            />

                            <c-lgs-event-group
                                :title    = "$t('todo.lgs.title')"
                                :measures = "lgsMeasures"
                                @click    = "onMeasure"
                            />

                            <p-inc-measure-group
                                title     = "ZÜS Prüfungen"
                                :measures = "assMeasures"
                                @click    = "onMeasure"
                            />

                            <p-inc-measure-group
                                v-if      = "isGuardReports"
                                title     = "Aufzugswärter Prüfungen"
                                :measures = "guardMeasures"
                                @click    = "onMeasure"
                            />
                        </div>
                    </div>
                </div>
            </v-col>
            <v-col class="no-border col-3" style="padding-left: 24px">
                <v-expand-x-transition>
                    <p-inc-assessment-delay-iterator
                        v-if        = "visible.delay"
                        :top-height = "topHeight"
                        :customer   = "todoState.selectedCustomer"
                        :all        = "todoState.allCustomer"
                        :liftmanagement = "onlyLM"
                        class       = "home-column"
                        @site       = "onSite"
                    />
                    <p-inc-required-fields-iterator
                        v-if        = "visible.missing"
                        :top-height = "topHeight"
                        :customer   = "todoState.selectedCustomer"
                        :all        = "todoState.allCustomer"
                        :liftmanagement = "onlyLM"
                        class       = "home-column"
                        @site       = "onSite"
                    />
                    <p-inc-site-down-iterator
                        v-if        = "visible.unitdown"
                        :top-height = "topHeight"
                        :customer   = "todoState.selectedCustomer"
                        :all        = "todoState.allCustomer"
                        :liftmanagement = "onlyLM"
                        class       = "home-column"
                        @site       = "onSite"
                    />
                    <p-inc-open-incident-iterator
                        v-if        = "visible.open"
                        :top-height = "topHeight"
                        :customer   = "todoState.selectedCustomer"
                        :all        = "todoState.allCustomer"
                        :liftmanagement = "onlyLM"
                        type        = "OPEN_INCIDENTS"
                        :title      = "$t('todo.open.title')"
                        class       = "home-column"
                        @site       = "onSite"
                    />
                    <p-inc-open-incident-iterator
                        v-if        = "visible.assessments"
                        :top-height = "topHeight"
                        :customer   = "todoState.selectedCustomer"
                        :all        = "todoState.allCustomer"
                        :liftmanagement = "onlyLM"
                        type        = "OPEN_ASSESSMENTS"
                        :title      = "$t('todo.assessment.maintitle')"
                        class       = "home-column"
                        @site       = "onSite"
                    />

                    <p-inc-open-incident-iterator
                        v-if        = "visible.invoices"
                        :top-height = "topHeight"
                        :customer   = "todoState.selectedCustomer"
                        :all        = "todoState.allCustomer"
                        :liftmanagement = "onlyLM"
                        type        = "OPEN_INVOICES"
                        :title      = "$t('todo.invoices.title')"
                        class       = "home-column"
                        @site       = "onSite"
                    />
                    <p-inc-open-incident-iterator
                        v-if        = "visible.maintenances"
                        :top-height = "topHeight"
                        :customer   = "todoState.selectedCustomer"
                        :all        = "todoState.allCustomer"
                        :liftmanagement = "onlyLM"
                        type        = "OPEN_MAINTENANCES"
                        :title      = "$t('todo.maintenance.title')"
                        class       = "home-column"
                        @site       = "onSite"
                    />
                    <p-inc-open-incident-iterator
                        v-if        = "visible.guardOpen"
                        :top-height = "topHeight"
                        :customer   = "todoState.selectedCustomer"
                        :all        = "todoState.allCustomer"
                        :liftmanagement = "onlyLM"
                        type        = "GUARD_OPEN"
                        :title      = "$t('todo.guard.open.title')"
                        class       = "home-column"
                        @site       = "onSite"
                    />
                    <p-inc-open-incident-iterator
                        v-if        = "visible.guardImported"
                        :top-height = "topHeight"
                        :customer   = "todoState.selectedCustomer"
                        :all        = "todoState.allCustomer"
                        :liftmanagement = "onlyLM"
                        type        = "GUARD_IMPORTED"
                        :title      = "$t('todo.guard.imported.title')"
                        class       = "home-column"
                        @site       = "onSite"
                    />
                    <p-inc-assessment-iterator
                        v-if        = "visible.minor"
                        :top-height = "topHeight"
                        :customer   = "todoState.selectedCustomer"
                        :type       = "2"
                        :title      = "$t('todo.assessment.title.minor')"
                        :all        = "todoState.allCustomer"
                        :liftmanagement = "onlyLM"
                        class       = "home-column"
                        @site       = "onSite"
                    />
                    <p-inc-assessment-iterator
                        v-if        = "visible.middle"
                        :top-height = "topHeight"
                        :customer   = "todoState.selectedCustomer"
                        :type       = "3"
                        :title      = "$t('todo.assessment.title.middle')"
                        :all        = "todoState.allCustomer"
                        :liftmanagement = "onlyLM"
                        class       = "home-column"
                        @site       = "onSite"
                    />
                    <p-inc-assessment-iterator
                        v-if        = "visible.major"
                        :top-height = "topHeight"
                        :customer   = "todoState.selectedCustomer"
                        :type       = "4"
                        :title      = "$t('todo.assessment.title.major')"
                        :all        = "todoState.allCustomer"
                        :liftmanagement = "onlyLM"
                        class       = "home-column"
                        @site       = "onSite"
                    />
                    <p-inc-assessment-iterator
                        v-if            = "visible.canceled"
                        :top-height.    = "topHeight"
                        :customer       = "todoState.selectedCustomer"
                        :type           = "5"
                        :title          = "$t('todo.assessment.title.canceled')"
                        :all            = "todoState.allCustomer"
                        :liftmanagement = "onlyLM"
                        class           = "home-column"
                        @site           = "onSite"
                    />
                    <p-inc-bounced-mail-iterator
                        v-if        = "visible.bounced"
                        :top-height = "topHeight"
                        class       = "home-column"
                        @site       = "onSite"
                        @mail       = "onMail"
                    />
                    <p-lgs-iterator
                        v-if        = "visible.standstill"
                        :top-height = "topHeight"
                        :customer   = "todoState.selectedCustomer"
                        :all        = "todoState.allCustomer"
                        event-type  = "STANDSTILL"
                        class       = "home-column"
                        @site       = "onSite"
                    />
                    <p-lgs-iterator
                        v-if        = "visible.longStandstill"
                        :top-height = "topHeight"
                        :customer   = "todoState.selectedCustomer"
                        :all        = "todoState.allCustomer"
                        event-type  = "LONG_STANDSTILL"
                        class       = "home-column"
                        @site       = "onSite"
                    />
                    <p-lgs-iterator
                        v-if        = "visible.unknown"
                        :top-height = "topHeight"
                        :customer   = "todoState.selectedCustomer"
                        :all        = "todoState.allCustomer"
                        event-type  = "UNKNOWN"
                        class       = "home-column"
                        @site       = "onSite"
                    />
                    <p-lgs-iterator
                        v-if        = "visible.resolved"
                        :top-height = "topHeight"
                        :customer   = "todoState.selectedCustomer"
                        :all        = "todoState.allCustomer"
                        event-type  = "RECENTLY_RECOVERED"
                        class       = "home-column"
                        @site       = "onSite"
                    />
                    <p-inc-guard-protocol-failed-iterator
                        v-if             = "visible.guardFailed"
                        :customer        = "todoState.selectedCustomer"
                        :top-height      = "topHeight"
                        :liftmanagement  = "onlyLM"
                        class            = "home-column"
                        @assigned        = "onGuardProtocolAssigned"
                        @deleted         = "onGuardProtocolDeleted"
                    />
                </v-expand-x-transition>
            </v-col>
        </v-row>
    </div>
</template>

<script>

import Core                            from "@/modules/core/service/Core";
import Inc                             from "@/modules/inc/service/Inc";
import Lgs                             from "@/modules/lgs/events/service/Lgs";
import PIncSiteDownIterator            from "@/modules/inc/todos/components/private/PIncSiteDownIterator.vue";
import PIncOpenIncidentIterator        from "@/modules/inc/todos/components/private/PIncOpenIncidentIterator.vue";
import PIncAssessmentDelayIterator     from "@/modules/inc/todos/components/private/PIncAssessmentDelayIterator.vue";
import PIncRequiredFieldsIterator      from "@/modules/inc/todos/components/private/PIncRequiredFieldsIterator.vue";
import PIncUnitsTotal                  from "@/modules/inc/todos/components/private/PIncUnitsTotal.vue";
import PIncMeasureGroup                from "@/modules/inc/todos/components/private/PIncMeasureGroup.vue";
import PIncAssessmentIterator          from "@/modules/inc/todos/components/private/PIncAssessmentIterator.vue";
import PIncBouncedMailIterator         from "@/modules/inc/todos/components/private/PIncBouncedMailIterator.vue";
import PIncBouncedMail                 from "@/modules/inc/todos/components/private/PIncBouncedMail.vue";
import CLgsEventGroup                  from "@/modules/lgs/events/components/CLgsEventGroup.vue";
import PLgsIterator                    from "@/modules/lgs/events/components/private/PLgsIterator.vue";
import PIncGuardProtocolFailedIterator from "@/modules/inc/todos/components/private/PIncGuardProtocolFailedIterator.vue";

export default {
    name: "CIncTodos",

    components: {
        PIncGuardProtocolFailedIterator,
        PLgsIterator,
        CLgsEventGroup,
        PIncBouncedMail,
        PIncBouncedMailIterator,
        PIncAssessmentIterator,
        PIncMeasureGroup,
        PIncUnitsTotal,
        PIncRequiredFieldsIterator,
        PIncAssessmentDelayIterator,
        PIncOpenIncidentIterator,
        PIncSiteDownIterator,
    },

    data: () => ({
        loading  : false,
        topHeight: 226,
        showSite : false,
        siteId   : null,
        loaded   : false,
        height   : null,
        onlyLM   : true,

        mail: {
            content: null,
            visible: false,
        },

        totals: {
            sitedown   : null,
            openissues : null,
            assessments: null,
            missing    : null,
            overdues   : null,
            asmminor   : null,
            asmmiddle  : null,
            asmmajor   : null,
            asmcanceled: null,
        },

        lgs: {
            standstill : null,
            absence    : null,
        },

        visible: {
            unitdown      : false,
            open          : false,
            invoices      : false,
            maintenances  : false,
            assessments   : false,
            missing       : false,
            delay         : false,
            minor         : false,
            middle        : false,
            major         : false,
            canceled      : false,
            bounced       : false,
            standstill    : false,
            longStandstill: false,
            unknown       : false,
            resolved      : false,
            guardOpen     : false,
            guardFailed   : false,
            guardImported : false
        },

        incMeasures: [
            { id: "unitdown",   name: "todo.sitedown.title",  measure: 0},
            { id: "open",       name: "todo.open.title",      measure: 0},
            { id: "assessments",name: "todo.assessment.maintitle",  measure: 0},
            { id: "invoices",   name: "todo.invoices.title",  measure: 0},
            { id: "missing",    name: "todo.missing.title",   measure: 0},
            { id: "maintenances",name: "todo.maintenance.title", measure: 0}
        ],

        guardMeasures: [
            { id: "guardImported", name: "todo.guard.imported.title",   measure: 0},
            { id: "guardFailed",   name: "todo.guard.failed.title",     measure: 0},
            { id: "guardOpen",     name: "todo.guard.open.title2",      measure: 0},
        ],


        lgsMeasures: [
            { id: "standstill",     name: "todo.lgs.STANDSTILL.title",      measure: 0},
            { id: "longStandstill", name: "todo.lgs.LONG_STANDSTILL.title", measure: 0},
            { id: "unknown",        name: "todo.lgs.UNKNOWN.title",         measure: 0},
            { id: "resolved",       name: "todo.lgs.resolved.title",        measure: 0, hint: "todo.lgs.resolved.hint"},
        ],

        assMeasures: [
            { id: "delay",      name: "todo.delay.title",               measure: 0 },
            { id: "minor",      name: "todo.assessment.title.minor",    measure: 0 },
            { id: "middle",     name: "todo.assessment.title.middle",   measure: 0 },
            { id: "major",      name: "todo.assessment.title.major",    measure: 0 },
            { id: "canceled",   name: "todo.assessment.title.canceled", measure: 0 },
        ],
    }),

    mounted() {
        this.onResize();
    },

    computed: {
        todoState () {
            return this.$store.getters.todo;
        },

        mailHeight () {
            return this.height - 62;
        },

        isPrivileged () {
            return Core.security.isPrivileged();
        },

        isGuardReports () {
            return Core.security.isGuardReports();
        },
    },

    watch: {
        onlyLM () {
            this.load();
        }
    },

    methods: {
        load () {
            this.loading = true;
            this.loaded = false;

            this.visible.unitdown   = false;
            this.visible. open      = false;
            this.visible.invoices   = false;
            this.visible.maintenances= false;
            this.visible.assessments= false;
            this.visible.missing    = false;
            this.visible.delay      = false;
            this.visible.minor      = false;
            this.visible.middle     = false;
            this.visible.major      = false;
            this.visible.canceled   = false;
            this.visible.bounced    = false;
            this.visible.standstill = false;
            this.visible.longstandstill = false;
            this.visible.absence        = false;
            this.visible.resolved       = false;
            this.visible.guardOpen      = false;
            this.visible.guardFailed    = false;
            this.visible.guardImported  = false;

            // Independent from Lgs.totals() below - both are separate data sources and a failure
            // in one must not prevent the other from loading (see the migration plan; this used to
            // be nested inside Inc.todo.totals()'s .then(), so a failure there silently swallowed
            // the LGS call too).
            Inc.todo.totals(this.todoState.selectedCustomer, this.todoState.allCustomer, this.onlyLM).then (totals => {
                this.totals = totals;
                this.incMeasures[0].measure = this.totals.sitedown;
                this.incMeasures[1].measure = this.totals.openissues;
                this.incMeasures[2].measure = this.totals.openassessments;
                this.incMeasures[3].measure = this.totals.openinvoices;
                this.incMeasures[4].measure = this.totals.missing;
                this.incMeasures[5].measure = this.totals.openmaintenances;

                this.assMeasures[0].measure = this.totals.overdues;
                this.assMeasures[1].measure = this.totals.asmminor;
                this.assMeasures[2].measure = this.totals.asmmiddle;
                this.assMeasures[3].measure = this.totals.asmmajor;
                this.assMeasures[4].measure = this.totals.asmcanceled;

                this.guardMeasures[0].measure = this.totals.guardImported;
                this.guardMeasures[1].measure = this.totals.guardFailed;
                this.guardMeasures[2].measure = this.totals.guardOpen;
            }).catch(() => {
            });

            Lgs.totals(this.todoState.selectedCustomer, this.todoState.allCustomer).then(lgs => {
                this.lgs = lgs;
                this.lgsMeasures [0].measure = this.lgs.unitState.STANDSTILL || 0;
                this.lgsMeasures [1].measure = this.lgs.unitState.LONG_STANDSTILL || 0;
                this.lgsMeasures [2].measure = this.lgs.unitState.UNKNOWN || 0;
                this.lgsMeasures [3].measure = this.lgs.recentlyRecoveredCount || 0;
            }).finally(() => {
                this.loaded = true;

                if (this.todoState.visible) {
                    this.visible[this.todoState.visible] = true;
                }

                this.loading = false;
            });
        },

        onChanged (todoState) {
            this.$store.dispatch("storeTodo", todoState).then(() => {
                this.load();
            })
        },

        onRefresh () {
            Core.loading(this, true);
            Inc.todo.reset().then (() => {
                Core.loading(this, false);
                this.load();
            }).catch(() => {
                Core.loading(this, false);
                this.load();
            })
        },

        onSite (siteId) {
            this.siteId = siteId;
            this.showSite = true;
        },

        onMail (mail) {
            this.mail.content = mail;
            this.mail.visible = "true";
        },

        onResize () {
            this.height = window.innerHeight-56;
        },

        onBounce () {
            this.onMeasure('bounced');
        },

        onMeasure (measure) {
            if (this.todoState.visible) {
                this.visible[this.todoState.visible] = false;

                if (this.todoState.visible === measure) {
                    this.todoState.visible = null;
                    this.persistVisible();
                    return;
                }

                this.$nextTick(()=> {
                    this.visible[measure] = true;
                    this.todoState.visible = measure;
                    this.persistVisible();
                });
            } else {
                this.visible[measure] = true;
                this.todoState.visible = measure;
                this.persistVisible();
            }
        },

        dateAsString (value) {
            return Core.format.date.display(value)
        },

        onGuardProtocolDeleted () {
            this.guardMeasures[1].measure--;
        },

        onGuardProtocolAssigned () {
            this.guardMeasures[1].measure--;
            this.guardMeasures[2].measure++;
        },

        // Only persists which tile is open - opening/closing a tile's detail list doesn't need a
        // totals reload at all (each iterator fetches its own list independently on mount).
        // Reloading here used to re-run BOTH Inc.todo.totals() and Lgs.totals() on every single
        // tile click, for no reason related to the click itself.
        persistVisible () {
            this.$store.dispatch("storeTodo", this.todoState);
        },
    },
}
</script>

<style scoped>

/* Replaces the old width:20%/40% + fixed margin-left/right layout: units-total panel and the
   groups container are now flex siblings sized by content/flex-basis and spaced with gap,
   instead of fixed-percentage widths and pixel margins standing in for spacing. */
.todo-layout {
    display: flex;
    align-items: flex-start;
    gap: 40px;
    /* The parent v-col carries Vuetify's legacy .v-flex (display:flex, row), so without
       growing here this div would only claim its content width instead of the column's. */
    flex: 1 1 auto;
    min-width: 0;
}

.todo-units-total {
    flex: 0 1 260px;
    min-width: 200px;
}

.todo-groups-container {
    flex: 1 1 0;
    min-width: 0;
}

.todo-groups-toolbar {
    display: flex;
    align-items: center;
    height: 26px;
    margin-bottom: 24px;
}

/* Always exactly 2 columns (2x2 for the 4 groups) - each measure group sizes itself naturally
   instead of relying on fixed pixel padding-top offsets between siblings, which used to be
   brittle to any change in a group's item count (e.g. adding a tile) or a group being
   conditionally hidden (isGuardReports). */
.todo-groups-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px 24px;
    align-items: start;
}

.home-column {
    width: calc(100% + 10px);
    margin-top: 12px;
}

::v-deep .empty-todos {
    position: absolute;
    top: 42px;
    width: calc(100% - 10px);
    text-align: center;
    padding: 8px;
}

</style>